import { Navigate, useParams } from 'react-router-dom';
import { conversaDoCodigo } from '../../../backend/src/services/whatsapp/link-conversa';

export default function ConversaLink() {
  const { codigo } = useParams();
  const conversa = conversaDoCodigo(codigo ?? '');
  return <Navigate replace to={conversa ? `/whatsapp-inbox?conversation=${conversa}` : '/whatsapp-inbox'} />;
}
